import { floorplanRasterScale } from "./floorplanRasterScale";

/** Decode locally and flatten to PNG so the endpoint receives one bounded format. */
export async function normalizeFloorplanImage(file: File): Promise<Blob> {
  if (file.size > 20 * 1024 * 1024)
    throw new Error("Choose an image smaller than 20 MB");
  if (!/\.(png|jpe?g|webp|svg)$/i.test(file.name))
    throw new Error("Choose a PNG, JPEG, WebP, or SVG image");
  const url = URL.createObjectURL(file);
  try {
    const image = new Image();
    image.src = url;
    await image.decode();
    if (!image.naturalWidth || !image.naturalHeight)
      throw new Error("The image has no dimensions");
    const scale = Math.min(
      1,
      floorplanRasterScale(image.naturalWidth, image.naturalHeight)
    );
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.floor(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.floor(image.naturalHeight * scale));
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Image conversion is unavailable");
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, "image/png")
    );
    if (!blob || blob.size > 12 * 1024 * 1024)
      throw new Error("Converted image is too large. Use a smaller image");
    return blob;
  } finally {
    URL.revokeObjectURL(url);
  }
}
